module.exports = __webpack_public_path__ + "img/Welhaven_Striden_mellom_Welhaven_og_Wergeland.a5522625.jpg";